import { Link } from 'react-router-dom'
import { listProducts } from '../../api/stock'
import { ErrorBox } from '../ui/Card'
import { useFetch } from '../../hooks/useFetch'
import { cn } from '@/lib/utils'
import { thClass, tdClass, tbodyHoverClass } from '@/lib/tableStyles'
import { DashboardWidgetCard } from './DashboardWidgetCard'

// Products don't have a configurable reorder threshold yet — this is a simple fixed
// cutoff so the widget is useful without a schema change. Worth revisiting as a
// per-product setting if this proves too coarse in practice.
const LOW_STOCK_THRESHOLD = 5

export function LowStockWidget() {
  const { data, loading, error } = useFetch(() => listProducts({ is_active: true }), [])

  const lowStock = (data ?? [])
    .filter(p => parseFloat(p.total_on_hand) <= LOW_STOCK_THRESHOLD)
    .sort((a, b) => parseFloat(a.total_on_hand) - parseFloat(b.total_on_hand))

  return (
    <DashboardWidgetCard title="Low Stock" viewAllHref="/stock" viewAllLabel="View Inventory">
      {loading ? (
        <div className="p-6 text-text-3 text-[0.875rem]">Loading…</div>
      ) : error ? (
        <div className="px-5 py-4"><ErrorBox className="mb-0">Could not load stock.</ErrorBox></div>
      ) : lowStock.length === 0 ? (
        <div className="px-5 py-6 text-text-3 text-[0.875rem]">All products are adequately stocked.</div>
      ) : (
        <table className="w-full border-collapse text-[0.875rem]">
          <thead>
            <tr>
              <th className={thClass}>Product</th>
              <th className={cn(thClass, 'text-right')}>On Hand</th>
              <th className={cn(thClass, 'text-right')}></th>
            </tr>
          </thead>
          <tbody className={tbodyHoverClass}>
            {lowStock.slice(0, 8).map(p => (
              <tr key={p.id}>
                <td className={tdClass}>{p.name}</td>
                <td className={cn(
                  tdClass, 'text-right font-semibold whitespace-nowrap',
                  parseFloat(p.total_on_hand) === 0 ? 'text-danger-text' : 'text-warning-text',
                )}>
                  {p.total_on_hand} {p.unit}
                </td>
                <td className={cn(tdClass, 'text-right')}>
                  <Link to={`/stock/register/${p.id}`} className="text-accent font-medium text-[0.8rem] no-underline hover:underline">
                    View →
                  </Link>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </DashboardWidgetCard>
  )
}
